import * as types from "./types";

export const addProduct = (product) => ({
  type: types.ADD_PRODUCT,
  product: product
});

export const updateProduct = (update) => ({
  type: types.UPDATE_PRODUCT,
  update: update
});

export const removeProduct = () => ({
  type: types.REMOVE_PRODUCT
});

export const toggleBuyButton = (status) => ({
  type: types.TOGGLE_BUY_MODAL,
  status: status
});

export const nextPage = (page) => ({
  type: types.NEXT_PAGE,
  page: page
});

export const previousPage = (page) => ({
  type: types.PREVIOUS_PAGE,
  page: page
});

export const setGroupType = (type) => ({ 
  type: types.SET_GROUPE_TYPE,
  group_type: type  // public || private
});

export const saveNewCircleDetails = (circle) => ({ 
  type: types.SAVE_NEW_CIRCLE_DETAILS,
  circle: circle   
});


 